import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapGetters('auth', ['getIsAuthenticated', 'getSecretKey', 'getAccessToken', 'getOAuthAccessToken', 'getOAuthRefreshToken', 'getAuthProvider', 'getjti'])
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}

export const applicationComputed = { ...mapGetters("application", ["GET_FILTER_APPLICATION","GET_APPLICATION_SELECTED"]) };
export const serviceComputed = { ...mapGetters("service", ["GET_FILTER_SERVICE"]) };
export const parameterComputed = { ...mapGetters("parameter", ["GET_FILTER_PARAMETER"]) };
export const userComputed = { ...mapGetters("user", ["GET_FILTER_USER"]) };
export const groupComputed = { ...mapGetters("group", ["GET_FILTER_GROUP"]) };
export const permissionComputed = { ...mapGetters("permission", ["GET_FILTER_PERMISSION"]) };
export const clientAppsComputed = { ...mapGetters("clientApps", ["GET_FILTER_CLIENT_APPS"]) };
export const techProductsComputed = { ...mapGetters("techProducts", ["GET_FILTER_TECH_PRODUCTS"]) };
export const roleComputed = { ...mapGetters("role", ["GET_FILTER_ROLE"]) };

// export const authenticationMethods = mapActions('authentication', ['setIsAuthentication','setAccessToken'])

export const authMethods = mapActions('auth', ['setIsAuthenticated', 'setSecretKey', 'setAccessToken', 'setOAuthAccessToken', 'setOAuthRefreshToken', 'setAuthProvider', 'setjti', 'removeAllAuthen', 'removeExpireToken','setCheckPermissionByElementFlag'])

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const authFackMethods = mapActions('authfack', ['login', 'registeruser', 'logout'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])

export const applicationMethods = mapActions("application", [
  "ADD_FILTER_APPLICATION",
  "CLEAR_FILTER_APPLICATION",
  "ADD_APPLICATION_SELECTED",
]);

export const serviceMethods = mapActions("service", [
  "ADD_FILTER_SERVICE",
  "CLEAR_FILTER_SERVICE",
]);

export const parameterMethods = mapActions("parameter", [
  "ADD_FILTER_PARAMETER",
  "CLEAR_FILTER_PARAMETER",
]);

export const userMethods = mapActions("user", [
  "ADD_FILTER_USER",
  "CLEAR_FILTER_USER",
]);

export const groupMethods = mapActions("group", [
  "ADD_FILTER_GROUP",
  "CLEAR_FILTER_GROUP",
]);

export const permissionMethods = mapActions("permission", [
  "ADD_FILTER_PERMISSION",
  "CLEAR_FILTER_PERMISSION",
]);

export const clientAppsMethods = mapActions("clientApps", [
  "ADD_FILTER_CLIENT_APPS",
  "CLEAR_FILTER_CLIENT_APPS",
]);

export const techProductsMethods = mapActions("techProducts", [
  "ADD_FILTER_TECH_PRODUCTS",
  "CLEAR_FILTER_TECH_PRODUCTS",
]);

export const roleMethods = mapActions("role", [
  "ADD_FILTER_ROLE",
  "CLEAR_FILTER_ROLE",
]);